import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GenerateBranchApiTokenResponse } from '@/api/handlers/resources/branches/responses';
import type { ApiResponse } from '@/api/handlers/responses';

/**
 * Fetches a branch's live POS API token so an admin can copy it (BOS-209).
 * A mutation rather than a query because it is a POST with a secret in the
 * response: nothing is cached, so the plaintext lives only in the caller's
 * hands for as long as it takes to reach the clipboard.
 */
export const useRevealBranchApiTokenMutation = () => {
    const { apiClient } = useApi();

    return useMutation<
        ApiResponse<GenerateBranchApiTokenResponse>,
        Error,
        string
    >({
        mutationFn: (branchId) => apiClient.branches.revealApiToken(branchId),
        gcTime: 0,
    });
};
